module.exports = __webpack_public_path__ + "static/media/nat-8.b5374a32.jpg";